// removed by extract-text-webpack-plugin
module.exports = {"root":"TemplateEditor__root___FwMVe","header":"TemplateEditor__header___g5Kaz","content":"TemplateEditor__content___1cwsj","toolsArea":"TemplateEditor__toolsArea___U7NeH","workArea":"TemplateEditor__workArea___1xHmQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateEditor/TemplateEditor.scss
// module id = 1038
// module chunks = 0